import { RouteConfig } from 'react-router-config';
import { GameConsoleLayoutRouter } from '../../pages/game-content';
import { ConsoleGameInfo } from '../../pages/game-content/game-info';
import { GameConsoleRouter } from '../../pages/game-content/game-console';
import { ConsoleOverview } from '../../pages/game-content/overview';
import { ConsoleAllProduct } from '../../pages/game-content/all-product';
import { NotFound } from '../../pages/not-found';

export const CONSOLE_ROUTE: RouteConfig[] = [
  {
    path: '/console',
    component: GameConsoleLayoutRouter,
    routes: [
      {
        path: '/console/overview/:gameId/:envId?',
        component: ConsoleOverview,
      },
      {
        path: '/console/game-info/:gameId/:envId?',
        component: ConsoleGameInfo,
      },
      {
        path: '/console/build/:gameId/:envId/:serviceId?',
        component: GameConsoleRouter,
      },
      {
        path: '/console/all-product/:gameId/:envId?',
        component: ConsoleAllProduct,
      },
      {
        path: '/console/',
        component: NotFound,
      },
    ],
  },
];
